import { render, staticRenderFns } from "./EmailTextArea.vue?vue&type=template&id=179f5067&scoped=true&"
import script from "./EmailTextArea.vue?vue&type=script&lang=js&"
export * from "./EmailTextArea.vue?vue&type=script&lang=js&"
import style0 from "./EmailTextArea.vue?vue&type=style&index=0&id=179f5067&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f5067",
  null
  
)

export default component.exports